package com.anjuros.website.templates.template5.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.templates.template5.modules.Template5ContactItem
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.anjuros.website.templates.template5.modules.getColor
import com.anjuros.website.templates.template5.styles.Template5ContactFooterLinkStyle
import com.anjuros.website.templates.template5.styles.Template5FooterSectionStyle
import com.anjuros.website.templates.template5.util.ResKey
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text


@OptIn(DelicateApi::class)
@Composable
fun Template5FooterSection() {

    var breakpoint = rememberBreakpoint()

    Column(
        modifier = Template5FooterSectionStyle.toModifier()
            .fillMaxWidth()
            .backgroundColor(Template5Theme.Primary.getColor()),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Link(
            path = "#home",
            modifier = Modifier.textDecorationLine(TextDecorationLine.None)
        ) {
            AnjurosLogo(
                modifier = Modifier
                    .height(70.px)
                    .margin(bottom = 10.px),
                src = "template5_logo_white.svg",
                alt = "Logo"
            )
        }

        P(
            attrs = Modifier
                .fontSize(18.px)
                .lineHeight(1.8)
                .textAlign(TextAlign.Center)
                .color(rgba(255,255,255,.82))
                .maxWidth(520.px)
                .margin(bottom = 36.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE5_CONTACT_CARD_FOOTER))
        }

        if (breakpoint >= Breakpoint.MD) {

            Row(

                horizontalArrangement = Arrangement.spacedBy(36.px),
                verticalAlignment = Alignment.CenterVertically
            ) {

                Template5ContactFooterList()

            }

        } else {

            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(18.px)
            ) {

                Template5ContactFooterList()

            }

        }

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(2.px)
                .backgroundColor(rgba(255,255,255,.18))
                .margin(
                    top = 20.px,
                    bottom = 10.px
                )
        )

        P(
            attrs = Modifier
                .fontSize(15.px)
                .color(rgba(255,255,255,.60))
                .textAlign(TextAlign.Center)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE5_FOOTER_COPYRIGHT))
        }

    }

}

@Composable
fun Template5ContactFooterList(){
    Template5FooterItem(
        icon =  "template5_contact1_white.svg",
        info = Template5ContactItem.Template5ContactItem1
    )

    Template5FooterItem(
        icon =  "template5_contact2_white.svg",
        info = Template5ContactItem.Template5ContactItem2
    )

    Template5FooterItem(
        icon =  "template5_contact4_white.svg",
        info = Template5ContactItem.Template5ContactItem4
    )
}

@Composable
private fun Template5FooterItem(
    icon: String,
    info: Template5ContactItem
) {
    Link(
        path = info.path,
        modifier = Modifier.textDecorationLine(TextDecorationLine.None)
    ) {
    Row(
        modifier = Template5ContactFooterLinkStyle.toModifier(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(10.px)
    ) {

        Image(
            modifier = Modifier.size(18.px),
            src = icon,
            alt = ""
        )


        Span(
            attrs = Modifier
                .id("contactFooterValue")
                .fontSize(16.px)
                .color(Colors.White)
                .toAttrs()
        ) {
            AnjurosText(info.value)
        }
    }

    }

}